var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEquityHouse = function SvgEquityHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#equity-house_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#equity-house_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.606 22.778c-45.951-41.82-71.715-14.774-86.656 0C13.666 31.87-3.878 31.425 3.705 80.737c9.96 64.775 39.281 38.639 51.462 38.638 15.937-.001 45.043-4.167 61.755-12.501 17.375-6.061 41.634-42.275-4.316-84.096Z",
    fill: "#EDF6FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.179 94.734c-46.576-12.263-72.69-4.332-87.835 0C12.893 97.4-4.889 97.27 2.797 111.73c10.096 18.994 39.815 11.33 52.162 11.33 16.153-.001 45.656-1.222 62.595-3.666 17.611-1.777 42.201-12.397-4.375-24.66Z",
    fill: "#57C975"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#equity-house_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.642 62.022c-5.278.212-9.725-4.022-9.714-9.319V15.728c-.011-5.297 4.436-9.53 9.714-9.319 5.143 0 9.313 4.173 9.313 9.319v36.975c0 5.15-4.17 9.319-9.313 9.319Z",
    fill: "#99EDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.669 109.466a.295.295 0 0 1-.295-.295V8.808c-.004-.383.594-.383.586 0V109.17a.295.295 0 0 1-.295.295h.004Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.669 28.289a.292.292 0 0 1-.238-.121l-7.192-9.894a.295.295 0 0 1 .064-.409.294.294 0 0 1 .408.065l7.193 9.893a.291.291 0 0 1-.065.409.299.299 0 0 1-.174.057h.004Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.02 23.54H9.127c-.382.004-.382-.594 0-.586h4.893c.382-.004.382.594 0 .586ZM17.717 36.306a.27.27 0 0 1-.23-.42l7.29-11.483c.19-.303.658 0 .465.295l-7.29 11.483a.272.272 0 0 1-.23.128l-.005-.003Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.314 31.735a.299.299 0 0 1-.273-.181.291.291 0 0 1 .16-.383l4.094-1.698a.292.292 0 0 1 .382.159.291.291 0 0 1-.159.382l-4.095 1.698a.304.304 0 0 1-.113.023h.004ZM17.718 50.626a.306.306 0 0 1-.227-.106L8.8 40.127a.293.293 0 0 1 .45-.374l8.69 10.392a.29.29 0 0 1-.038.413.298.298 0 0 1-.19.068h.005ZM17.817 56.221a.294.294 0 0 1-.227-.48l6.492-7.896c.238-.299.7.083.454.37l-6.493 7.897a.288.288 0 0 1-.226.106v.003Z",
    fill: "#566C77"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#equity-house_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.721 57.895c0 10.893-8.891 19.723-19.858 19.723-26.313-.967-26.307-38.486 0-39.448 10.967 0 19.858 8.83 19.858 19.724Z",
    fill: "#99EDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.715 104.059a.29.29 0 0 1-.29-.288V53.332c-.006-.373.586-.373.58 0v50.442a.29.29 0 0 1-.29.288v-.003Z",
    fill: "#566C77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.614 64.217a.292.292 0 0 1-.225-.105l-4.149-5.006a.287.287 0 0 1 .042-.406.289.289 0 0 1 .408.038l4.149 5.006a.292.292 0 0 1-.225.473ZM119.711 71.381a.283.283 0 0 1-.171-.056.286.286 0 0 1-.062-.403l5.336-7.163a.29.29 0 0 1 .405-.059c.13.094.157.274.062.403l-5.336 7.163a.29.29 0 0 1-.234.118v-.003Z",
    fill: "#566C77"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#equity-house_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.703 32.006h.035l23.39 37.205h-7.925L92.567 35.79l2.136-3.784Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.406 67.995v40.484H19.198V69.553c.242 0 40.184-.443 48.705-.534.835-.012 1.213-.017 1.586-.017l.798-1.169 24.416-35.827 19.616 35.83.087.161v-.002Z",
    fill: "#D5EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.406 67.995v1.148H67.902v-1.31h46.417l.087.162Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.349 69.002v39.477h-50.15V69.553c.265 0 47.237-.518 50.15-.55Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.557 29.533h-9.002v8.344h9.002v-8.344Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.554 33.201v2.479l-9 .398v-1.099l9-1.778Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.703 32.006-2.084 3.09-.188.281-1.905 2.835-.183.274-1.91 2.832-.186.276-1.903 2.833-.19.276-1.906 2.828-.183.28-1.906 2.828-.183.274-1.903 2.828-.185.276-1.903 2.827-.183.274-1.906 2.823-.183.274-1.9 2.83-.189.274-1.9 2.823-.184.274-1.96 2.91-54.289 1.007 1.415-2.296.167-.274 1.682-2.731.174-.274 1.683-2.736.173-.275 1.685-2.738.167-.274 1.69-2.736.166-.274 1.69-2.739.167-.274 1.69-2.736.17-.281 1.685-2.736.172-.279 1.69-2.738.173-.28 1.687-2.735.17-.281 1.69-2.741.17-.276 1.432-2.322 57.824-3.3Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.406 92.936H19.198v15.541h95.208v-15.54Z",
    fill: "#7397BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.17 92.936h-.54v15.541h.54v-15.54ZM23.92 92.936h-.54v15.541h.54v-15.54ZM26.678 92.936h-.54v15.541h.54v-15.54ZM29.434 92.936h-.54v15.541h.54v-15.54ZM32.188 92.936h-.54v15.541h.54v-15.54ZM34.945 92.936h-.54v15.541h.54v-15.54ZM37.699 92.936h-.54v15.541h.54v-15.54ZM40.456 92.936h-.54v15.541h.54v-15.54ZM43.213 92.936h-.54v15.541h.54v-15.54ZM45.965 92.936h-.54v15.541h.54v-15.54ZM48.722 92.936h-.54v15.541h.54v-15.54ZM51.481 92.936h-.54v15.541h.54v-15.54ZM54.234 92.936h-.54v15.541h.54v-15.54ZM56.99 92.936h-.54v15.541h.54v-15.54ZM59.748 92.936h-.54v15.541h.54v-15.54ZM62.5 92.936h-.54v15.541h.54v-15.54ZM65.258 92.936h-.54v15.541h.54v-15.54ZM68.01 92.936h-.539v15.541h.54v-15.54Z",
    fill: "#8CB3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.87 92.936h-.54v15.541h.54v-15.54ZM74.626 92.936h-.54v15.541h.54v-15.54ZM77.383 92.936h-.54v15.541h.54v-15.54ZM80.137 92.936h-.54v15.541h.54v-15.54ZM82.895 92.936h-.54v15.541h.54v-15.54ZM85.652 92.936h-.54v15.541h.54v-15.54ZM88.404 92.936h-.54v15.541h.54v-15.54ZM91.161 92.936h-.54v15.541h.54v-15.54ZM93.914 92.936h-.54v15.541h.54v-15.54ZM96.673 92.936h-.54v15.541h.54v-15.54ZM99.429 92.936h-.54v15.541h.54v-15.54ZM102.183 92.936h-.54v15.541h.54v-15.54ZM104.938 92.936h-.539v15.541h.539v-15.54ZM107.697 92.936h-.539v15.541h.539v-15.54ZM110.45 92.936h-.54v15.541h.54v-15.54ZM113.207 92.936h-.54v15.541h.54v-15.54Z",
    fill: "#D5EAFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.493 74.599h-9.621v15.313h9.621V74.599Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.492 75.376v.612l3.543 9.12 4.27 3.977h.567V75.376h-8.38Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.274 75.978h-7.782v13.107h7.782V75.98Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.38 81.315H76.15v.618h9.232v-.618ZM105.462 74.599H95.84v15.313h9.622V74.599Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.461 75.376v.612l3.541 9.12 4.272 3.977h.567V75.376h-8.38Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.243 75.978h-7.782v13.107h7.782V75.98Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.348 81.315h-9.232v.618h9.232v-.618ZM99.387 55.573c0 3.343-2.6 6.05-5.81 6.05-7.698-.292-7.695-11.81 0-12.103 3.208 0 5.81 2.71 5.81 6.05v.003Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.685 55.572c0 1.6-.678 3.039-1.753 4.013-5.027 4.23-11.182-2.574-7.209-7.51 3.065-3.706 9-1.352 8.962 3.495v.002Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22 56.053a5.47 5.47 0 0 1-1.288 3.535c-5.027 4.23-11.182-2.575-7.209-7.51 3.236-3.055 8.56-.518 8.498 3.975Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.238 49.749h-.617v11.507h.617V49.749Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.147 55.228H88.1v.642h11.048v-.642ZM33.871 74.597H24.25V89.91h9.622V74.597Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 75.376v.605l-4.503 8.628-3.308 4.476h-.568V75.376h8.38Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 75.978h-7.782v13.107h7.782V75.98Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.595 81.315h-9.232v.618h9.232v-.618ZM64.433 74.597H54.81V89.91h9.622V74.597Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.812 75.376v.605l-4.503 8.628-3.311 4.476h-.566V75.376h8.38Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.812 75.978H56.03v13.107h7.782V75.98Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.158 81.315h-9.233v.618h9.233v-.618Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.395 77.394h-14.79v31.083h14.79V77.394Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.44 78.234H37.387v29.54H51.44v-29.54Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.762 106.964h-12.7a.134.134 0 0 1-.135-.136V79.045c0-.075.061-.136.134-.136h12.7c.076 0 .134.061.134.136v27.783a.136.136 0 0 1-.133.136Zm-12.567-.27h12.43V79.181h-12.43v27.513Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15 91.146h-3.352a.134.134 0 0 1-.133-.136V80.054c0-.075.06-.136.133-.136h3.354c.075 0 .134.061.134.136V91.01a.136.136 0 0 1-.134.136h-.002Zm-3.22-.271h3.083V80.188H39.93v10.687ZM49.12 91.147h-3.354a.134.134 0 0 1-.134-.136V80.055c0-.075.061-.136.134-.136h3.353c.075 0 .134.06.134.136V91.01a.136.136 0 0 1-.134.136Zm-3.218-.272h3.084V80.188h-3.084v10.687ZM43.15 104.944h-3.352a.134.134 0 0 1-.133-.136V93.85c0-.075.06-.136.133-.136h3.354c.075 0 .134.06.134.136v10.958a.136.136 0 0 1-.134.136h-.002Zm-3.22-.269h3.083v-10.69H39.93v10.69ZM49.12 104.944h-3.354a.134.134 0 0 1-.134-.136V93.85c0-.075.061-.136.134-.136h3.353c.075 0 .134.06.134.136v10.958a.136.136 0 0 1-.134.136Zm-3.218-.269h3.084v-10.69h-3.084v10.69ZM116.748 107.652H15.063v1.926h101.685v-1.926Z",
    fill: "#053249"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "equity-house_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .362)",
    d: "M0 0h140v124.937H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equity-house_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.933 .455)",
    d: "M0 0h145.6v125.067H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equity-house_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.928 6.401)",
    d: "M0 0h19.027v103.065H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equity-house_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(100.127 38.17)",
    d: "M0 0h39.873v66.456H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "equity-house_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15.063 29.533)",
    d: "M0 0h103.065v80.045H0z"
  })))));
};
export default SvgEquityHouse;